import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import ScheduleItem from "./schedule.item.component";
import ScheduleService from "../../services/schedule.service";
import PFDateAndDesc from "../../common/pfDateAndDesc";

const Schedule = () => {

    const [scheduledVenues, setScheduledVenues] = useState([])

    const fetchSchedule = () => {
        ScheduleService.getSchedule().then(
            response => {
                setScheduledVenues(response.data.data);
                console.log("scheduledVenues:" + JSON.stringify(response.data.data));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount
    useEffect(() => {
        fetchSchedule();
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Schedule</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <PFDateAndDesc/>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Table bordered hover size="lg" responsive className="schedule-table">
                            <thead>
                            <tr>
                                <th>Location</th>
                                <th width="21%">12pm - 1:00pm</th>
                                <th width="21%">1:30pm - 2:30pm</th>
                                <th width="21%">3:00pm - 4:00pm</th>
                                <th width="21%">4:30pm - 5:30pm</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td colSpan={5} style={{textAlign: "center", height: "75px", background: "#ffffea"}}
                                    className="align-middle">
                                    Porchfest Finale: Diver9 at The Griffin Museum Terrace (67 Shore Rd) from 6:00p to
                                    7:30p
                                </td>
                            </tr>
                            {scheduledVenues.length > 0 &&
                                scheduledVenues.map((si) => (
                                        <tr key={si.id}>
                                            <td>
                                                <Link to={si.address_url} target="_blank"
                                                      reloadDocument="true"><span
                                                    style={{textTransform: 'capitalize'}}>{si.address}</span></Link>
                                            </td>
                                            {si.slot_1 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_1}/>
                                                </td>
                                            }
                                            {si.slot_1 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_2 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_2}/>
                                                </td>
                                            }
                                            {si.slot_2 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_3 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_3}/>
                                                </td>
                                            }
                                            {si.slot_3 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }

                                            {si.slot_4 !== null &&
                                                <td className="schedule-td">
                                                    <ScheduleItem siSlot={si.slot_4}/>
                                                </td>
                                            }
                                            {si.slot_4 == null &&
                                                <td className="schedule-td-unavailable"></td>
                                            }
                                        </tr>
                                    )
                                )
                            }
                            <tr>
                                <td colSpan={5} style={{textAlign: "center", height: "75px", background: "#ffffea"}}
                                    className="align-middle">
                                    Porchfest Finale: Diver9 at The Griffin Museum Terrace (67 Shore Rd) from 6:00p to
                                    7:30p
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Schedule;
